import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sectionA", "sectionB", "button"]
  static values = { textA: String, textB: String, activeSection: { type: String, default: "a" } }

  declare sectionATarget: HTMLElement
  declare sectionBTarget: HTMLElement
  declare buttonTarget: HTMLElement
  declare textAValue: string
  declare textBValue: string
  declare activeSectionValue: string

  connect() {
    if (this.activeSectionValue === "b") {
      this.sectionATarget.setAttribute("hidden", "")
      this.sectionBTarget.removeAttribute("hidden")
      this.buttonTarget.textContent = this.textAValue
    }
  }

  toggle() {
    this.sectionATarget.toggleAttribute("hidden")
    this.sectionBTarget.toggleAttribute("hidden")

    if (this.sectionATarget.hasAttribute("hidden")) {
      this.buttonTarget.textContent = this.textAValue
    } else {
      this.buttonTarget.textContent = this.textBValue
    }
  }
}
